export default function Breadcrumb() {
  return (
    <div className="w-full bg-background-100 border-b border-background-200">
      <nav
        aria-label="面包屑导航"
        className="w-full px-4 md:px-8 py-3 flex items-center gap-2 text-xs md:text-sm text-foreground-500"
      >
        <a href="#top" className="hover:text-primary-700 whitespace-nowrap flex items-center gap-1.5">
          <i className="ri-home-4-line"></i>
          首页
        </a>
        <i className="ri-arrow-right-s-line text-foreground-300"></i>
        <span className="text-foreground-700 whitespace-nowrap">投稿规则</span>
        <i className="ri-arrow-right-s-line text-foreground-300"></i>
        <span className="text-foreground-900 whitespace-nowrap" aria-current="page">
          爆料投稿指南
        </span>
      </nav>
    </div>
  );
}